module.exports = __webpack_public_path__ + "img/bsed-serial-number.3c5df0fb.png";